module.exports = __WEBPACK_EXTERNAL_MODULE_148__;


//////////////////
// WEBPACK FOOTER
// external "core-js/modules/es6.function.bind"
// module id = 148
// module chunks = 0